/**
 * Lightweight logger utility for the frontend application.
 *
 * - `logger.error` always logs (production + development) so critical errors are visible.
 * - `logger.info`, `logger.warn`, and `logger.debug` only log in development mode
 *   (guarded by `import.meta.env.DEV`) to keep the production console clean.
 */

// `import.meta.env` is a Vite-only construct: it's `undefined` when this module
// is imported from a plain Node/tsx context (e.g. scripts/prerender-public-pages.ts,
// run after `vite build`), where `import.meta.env.DEV` throws and aborts the
// prerender → the deploy. Read it defensively so the logger is safe in BOTH the
// Vite browser build (where Vite statically inlines the value) and Node.
const isDev = (import.meta as unknown as { env?: { DEV?: boolean } }).env?.DEV ?? false

export const logger = {
  info: (...args: unknown[]) => {
    if (isDev) console.warn(...args)
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args)
  },
  error: (...args: unknown[]) => {
    console.error(...args)
  },
  debug: (...args: unknown[]) => {
    if (isDev) console.warn(...args)
  },
}
